import { ArrowLeft, ChartLine as LineChart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface BetaComingSoonProps {
  featureName: string;
  description: string;
}

export default function BetaComingSoon({ featureName, description }: BetaComingSoonProps) {
  const navigate = useNavigate();

  return (
    <div className="app-page flex min-h-[calc(100vh-4rem)] items-center justify-center py-12">
      <div className="w-full max-w-xl border border-app-line bg-app-surface p-6 sm:p-9">
        <div className="flex items-start justify-between gap-6 border-b border-app-line pb-7">
          <div>
            <span className="app-kicker">Product access</span>
            <h1 className="mt-3 text-3xl font-bold text-app-ink">{featureName}</h1>
          </div>
          <div className="flex h-12 w-12 shrink-0 items-center justify-center border border-app-line bg-app-surface-raised text-app-brand">
            <LineChart className="h-6 w-6" aria-hidden="true" />
          </div>
        </div>

        <div className="py-7">
          <div className="mb-5 inline-flex items-center gap-2 border border-app-warning/30 bg-app-warning/10 px-2.5 py-1 text-xs font-bold uppercase text-app-warning">
            <span className="h-1.5 w-1.5 rounded-full bg-app-warning" />
            Beta access
          </div>
          <p className="max-w-md text-base leading-relaxed text-app-muted">{description}</p>
          <p className="mt-5 border-l-2 border-app-accent pl-4 text-sm leading-relaxed text-app-muted">
            This feature is available to selected organisations during beta. Contact your organisation administrator to request access.
          </p>
        </div>

        <button onClick={() => navigate('/app')} className="btn-secondary">
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          Back to accounts
        </button>
      </div>
    </div>
  );
}
